import { registerPlugin, type PluginListenerHandle } from '@capacitor/core'

/**
 * Native iOS keyboard accessory bar (Prev / Next / Done) for the web form fields.
 * Backed by `KeyboardAccessoryPlugin.swift`, which swizzles `WKContentView`'s
 * `inputAccessoryView`. Button taps arrive as `prev` / `next` / `done` events.
 * iOS-only — calls are no-ops on other platforms.
 */
export interface KeyboardAccessoryPlugin {
  /** Turn the custom accessory bar on (while the form screen is mounted). */
  enable(): Promise<void>
  /** Restore the default keyboard accessory. */
  disable(): Promise<void>
  /** Enable/disable the Prev and Next buttons (greyed out at the ends). */
  setState(opts: { hasPrev: boolean; hasNext: boolean }): Promise<void>
  addListener(
    event: 'prev' | 'next' | 'done',
    cb: () => void
  ): Promise<PluginListenerHandle>
}

export const KeyboardAccessoryNative =
  registerPlugin<KeyboardAccessoryPlugin>('KeyboardAccessory')
